/**
 * Contains a list of labels to rotate in the app.
 */

const strings = [
  'that understands your minhagim',
  'that respects your privacy',
  'that puts zmanim on your watch',
  'that works offline',
  'more accurate than any website',
  'that works anywhere'
]

export default strings
